/* ============================================================
   RYVA · Selector visual de lente (estilo galería premium)
   + Banner de oferta 2X1 (descuento automático por colección)
   - GoldenDay / UltraFocus / CalmVision: reemplaza el selector
     de puntos (.ryva-lens) por miniaturas con la foto del lente.
   - DRISHTI (5 productos): inyecta el selector debajo del precio.
   La etiqueta muestra el BENEFICIO del lente (no el color).
   Cargado desde snippets/copy-toast.liquid
   i18n: textos desde window.RYVA_I18N (snippets/ryva-js-i18n.liquid).
   ============================================================ */
(function () {
  function RY(k, fb) {
    var d = window.RYVA_I18N;
    return (d && typeof d[k] === 'string' && d[k].length) ? d[k] : fb;
  }

  var CDN = 'https://cdn.shopify.com/s/files/1/0733/7446/6095/files/';
  var LINE = [
    { h: 'ryva-morning-goldenday', n: RY('c_day', 'Día'), b: RY('b_soft_focus', 'Enfoque suave'), img: CDN + 'IMG-1283.png?v=1782317257&width=360' },
    { h: 'ryva-afternoon-ultrafocus', n: RY('c_afternoon', 'Tarde'), b: RY('b_max_focus', 'Máximo enfoque'), img: CDN + 'IMG-1285.png?v=1782317922&width=360' },
    { h: 'ryva-night-calmvision', n: RY('c_night', 'Noche'), b: RY('b_sleep_better', 'Duerme mejor'), img: CDN + 'IMG-1284.png?v=1782317679&width=360' }
  ];
  var DRISHTI = [
    { h: 'drishti-negro-amarillo', n: RY('c_black_yellow', 'Negro / Amarillo'), b: RY('b_focus_nofatigue', 'Enfoque sin fatiga'), img: CDN + 'negro_amarillo.png?v=1784273687&width=360' },
    { h: 'drishti-negro-naranja', n: RY('c_black_orange', 'Negro / Naranja'), b: RY('b_prep_night', 'Prepara la noche'), img: CDN + 'negro_naranja2.png?v=1784272968&width=360' },
    { h: 'drishti-gris-translucido-naranja', n: RY('c_crystal_orange', 'Cristal / Naranja'), b: RY('b_prep_night', 'Prepara la noche'), img: CDN + 'cristal_naranja.png?v=1784273976&width=360' },
    { h: 'drishti-negro-rojo-vino', n: RY('c_black_wine', 'Negro / Rojo Vino'), b: RY('b_deep_rest', 'Descanso profundo'), img: CDN + 'negro_rojo1.png?v=1784273381&width=360' },
    { h: 'drishti-cristal-rojo-vino', n: RY('c_crystal_wine', 'Cristal / Rojo Vino'), b: RY('b_deep_rest', 'Descanso profundo'), img: CDN + 'cristal_rojo.png?v=1784274151&width=360' }
  ];

  function findIdx(list, path) {
    for (var i = 0; i < list.length; i++) {
      if (path.indexOf('/products/' + list[i].h) !== -1) return i;
    }
    return -1;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function init() {
    var path = location.pathname.toLowerCase();
    var opts = null, cur = -1;
    var cols = 5; /* tamaño de miniatura uniforme en todas las páginas */
    var di = findIdx(DRISHTI, path);
    if (di !== -1) { opts = DRISHTI; cur = di; }
    else {
      var gi = findIdx(LINE, path);
      if (gi !== -1) { opts = LINE; cur = gi; }
    }

    function directChildOf(el, parent) {
      var a = el;
      while (a.parentElement && a.parentElement !== parent) a = a.parentElement;
      return a.parentElement === parent ? a : null;
    }

    /* --- SETS: banner "2º lente gratis" (sin selector) --- */
    if (!opts) {
      var SETS = ['ryva-bundle-day-night', 'ryva-bundle-total-focus', 'bundle-full-protection', 'ryva-bundle-deep-rest'];
      var isSet = false;
      for (var s = 0; s < SETS.length; s++) { if (path.indexOf('/products/' + SETS[s]) !== -1) { isSet = true; break; } }
      if (!isSet) return;

      if (!document.getElementById('ryva-setpromo-css')) {
        var sst = document.createElement('style');
        sst.id = 'ryva-setpromo-css';
        sst.textContent =
          ".ryva-setpromo{font-family:'Poppins',sans-serif;margin:18px 0;color:#0a0a0a}" +
          '.ryva-setpromo__bar{display:flex;align-items:center;gap:10px;background:#e8f8ee;border-radius:8px;padding:13px 14px}' +
          '.ryva-setpromo__bar svg{width:19px;height:19px;flex:0 0 auto;display:block}' +
          '.ryva-setpromo__bar span{font-size:12px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:#0a0a0a;line-height:1.3}' +
          '.ryva-setpromo__note{font-size:10.5px;font-weight:400;letter-spacing:.01em;color:#8f8f8f;margin-top:7px}';
        document.head.appendChild(sst);
      }

      var is3 = path.indexOf('/products/bundle-full-protection') !== -1;
      var bigTxt = is3 ? RY('set_free_3rd', 'El 3er lente, gratis') : RY('set_free_2nd', 'El 2º lente, gratis');
      var noteTxt = is3
        ? RY('set_note_3', 'Pagas 2, llevas 3 · Ahorras 33%')
        : RY('set_note_2', 'Pagas 1, llevas 2 · Ahorras 50%');
      var snode = document.createElement('div');
      snode.className = 'ryva-setpromo';
      snode.innerHTML =
        '<div class="ryva-setpromo__bar">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#0a0a0a" d="M12 1.6l2.3 2 3-.7 1.1 2.9 2.9 1.1-.7 3 2 2.3-2 2.3.7 3-2.9 1.1-1.1 2.9-3-.7-2.3 2-2.3-2-3 .7-1.1-2.9L2.7 17l.7-3-2-2.3 2-2.3-.7-3 2.9-1.1L6.7 2.9l3 .7z"/><path fill="#e8f8ee" d="M9.2 7.6c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6-1.6-.7-1.6-1.6.7-1.6 1.6-1.6zm5.6 5.6c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6-1.6-.7-1.6-1.6.7-1.6 1.6-1.6zM14.6 7.2l1.5 1.1-6.7 8.5-1.5-1.1z"/></svg>' +
          '<span>' + esc(bigTxt) + '</span>' +
        '</div>' +
        '<div class="ryva-setpromo__note">' + esc(noteTxt) + '</div>';

      var sdetails = document.querySelector('.main-product__details') || document.body;
      var sprice = sdetails.querySelector('.price');
      if (sprice) { var sa = directChildOf(sprice, sdetails); if (sa) { sa.insertAdjacentElement('afterend', snode); return; } }
      var sq2 = sdetails.querySelector('quantity-input, .quantity, [name="quantity"]');
      if (sq2) { var sa2 = directChildOf(sq2, sdetails); if (sa2) { sa2.insertAdjacentElement('beforebegin', snode); return; } }
      return;
    }

    /* estilos (una sola vez) */
    if (!document.getElementById('ryva-lens2-css')) {
      var st = document.createElement('style');
      st.id = 'ryva-lens2-css';
      st.textContent =
        ".ryva-lens2{font-family:'Poppins',sans-serif;margin:18px 0;color:#0a0a0a}" +
        '.ryva-lens2 *{box-sizing:border-box}' +
        '.ryva-lens2__label{font-size:10px;font-weight:400;letter-spacing:.18em;text-transform:uppercase;color:#a3a3a3;margin-bottom:13px}' +
        '.ryva-lens2__label b{color:#111;font-weight:500;letter-spacing:.14em}' +
        '.ryva-lens2__grid{display:grid;grid-template-columns:repeat(var(--rl-cols,5),1fr);gap:8px}' +
        '.ryva-lens2__opt{display:block;position:relative;border:1px solid #e4e4e4;border-radius:8px;background:#f7f7f6;overflow:hidden;text-decoration:none;transition:border-color .15s ease}' +
        '.ryva-lens2__opt img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover}' +
        '.ryva-lens2__opt:hover{border-color:#bdbdbd}' +
        '.ryva-lens2__opt.is-active{border-color:#0a0a0a;box-shadow:inset 0 0 0 1px #0a0a0a;cursor:default}' +
        '.ryva-lens2__promo{display:flex;align-items:center;gap:10px;background:#e8f8ee;border-radius:8px;padding:13px 14px;margin-top:14px}' +
        '.ryva-lens2__promo svg{width:19px;height:19px;flex:0 0 auto;display:block}' +
        '.ryva-lens2__promo span{font-size:12px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:#0a0a0a;line-height:1.3}' +
        '.ryva-lens2__note{font-size:10.5px;font-weight:400;letter-spacing:.01em;color:#8f8f8f;margin-top:7px}' +
        '@media (max-width:560px){.ryva-lens2__grid{gap:6px}}';
      document.head.appendChild(st);
    }

    /* construir el selector */
    var node = document.createElement('div');
    node.className = 'ryva-lens2';
    node.style.setProperty('--rl-cols', cols);

    var label = document.createElement('div');
    label.className = 'ryva-lens2__label';
    label.innerHTML = esc(RY('lens_label', 'Lente')) + ' — <b></b>';
    label.querySelector('b').textContent = opts[cur].b || opts[cur].n;
    node.appendChild(label);

    var grid = document.createElement('div');
    grid.className = 'ryva-lens2__grid';
    opts.forEach(function (o, idx) {
      var active = idx === cur;
      var el = document.createElement(active ? 'div' : 'a');
      el.className = 'ryva-lens2__opt' + (active ? ' is-active' : '');
      if (!active) {
        el.href = '/products/' + o.h;
        el.setAttribute('aria-label', (o.b || o.n) + ' — ' + RY('see_lens', 'ver lente'));
      }
      var im = document.createElement('img');
      im.src = o.img;
      im.alt = 'RYVA — ' + o.n;
      im.loading = 'lazy';
      el.appendChild(im);
      grid.appendChild(el);
    });
    node.appendChild(grid);

    /* banner de oferta 2X1 (verde) + nota */
    var promo = document.createElement('div');
    promo.className = 'ryva-lens2__promo';
    promo.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#0a0a0a" d="M12 1.6l2.3 2 3-.7 1.1 2.9 2.9 1.1-.7 3 2 2.3-2 2.3.7 3-2.9 1.1-1.1 2.9-3-.7-2.3 2-2.3-2-3 .7-1.1-2.9L2.7 17l.7-3-2-2.3 2-2.3-.7-3 2.9-1.1L6.7 2.9l3 .7z"/><path fill="#e8f8ee" d="M9.2 7.6c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6-1.6-.7-1.6-1.6.7-1.6 1.6-1.6zm5.6 5.6c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6-1.6-.7-1.6-1.6.7-1.6 1.6-1.6zM14.6 7.2l1.5 1.1-6.7 8.5-1.5-1.1z"/></svg>' +
      '<span>' + esc(RY('promo_2x1', 'Llevas 2, pagas 1')) + '</span>';
    node.appendChild(promo);

    var note = document.createElement('div');
    note.className = 'ryva-lens2__note';
    note.textContent = RY('promo_2x1_note', 'Tu 2º lente gratis · Descuento automático.');
    node.appendChild(note);

    var details = document.querySelector('.main-product__details') || document.body;

    /* 1) páginas GoldenDay/UltraFocus/CalmVision: reemplazar el selector de puntos */
    var old = details.querySelector('.ryva-lens');
    if (old) { old.replaceWith(node); return; }

    /* 2) páginas DRISHTI: insertar debajo del precio */
    var price = details.querySelector('.price');
    if (price) {
      var anchor = directChildOf(price, details);
      if (anchor) { anchor.insertAdjacentElement('afterend', node); return; }
    }
    var q = details.querySelector('quantity-input, .quantity, [name="quantity"]');
    if (q) {
      var a2 = directChildOf(q, details);
      if (a2) { a2.insertAdjacentElement('beforebegin', node); return; }
    }
    /* fallback: no romper nada si el tema cambia */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();